<template>
  <div class="login">
    <img class="img" src="../../assets/dash/dash-icon1.png" alt="" />
    <div class="login_box">
      <div class="title">登录平台</div>
      <div class="user">
        <img class="login_img" src="../../assets/login.png" alt="" />
        <van-field
          style="width: 90%; height: 100%; background-color: #f5f7fbff"
          v-model="text"
          placeholder="请输入账号"
        />
      </div>
      <div class="user">
        <img class="login_img" src="../../assets/login1.png" alt="" />
        <van-field
          style="width: 90%; height: 100%; background-color: #f5f7fbff"
          v-model="password"
          type="password"
          placeholder="请输入密码"
        />
      </div>
      <div class="but" @click="onBut">登录</div>
    </div>
    <div class="bot_title">版权所有：陕西关山草原旅游发展有限责任公司</div>
  </div>
</template>
<script>
import request from "@/api/index";
import { Dialog, Toast, ImagePreview } from "vant";
export default {
  data() {
    return {
      text: "",
      password: "",
    };
  },
  mounted() {
    200;
  },
  methods: {
    //登录
    async onBut() {
      if (!this.text) {
        Toast("请输入账号");
        return;
      }
      if (!this.password) {
        Toast("请输入密码");
        return;
      }
      const res = await request.BySM2();
      console.log(res, res.data.data.publicKey, res.data.status);
      if (res.data.status == 1) {
        let publicKey = res.data.data.publicKey;
        let redisKey = res.data.data.redisKey;
        let nuserNme = this.$getSm2Code(publicKey, this.text);
        let passsword = this.$getSm2Code(publicKey, this.password);
        const Lres = await request.Login(nuserNme, passsword, redisKey);
        console.log(Lres.data.error, Lres.status);
        if (Lres.data.access_token) {
          sessionStorage.setItem("token", Lres.data.access_token);
          this.$router.push({ path: "/dashboard" });
        } else {
          Toast(Lres.data.error);
        }
      }
    },
  },
};
</script>
<style scoped>
@import "Newlogin.css";
</style>